import { render, staticRenderFns } from "./OptionalArticlesContainer.vue?vue&type=template&id=37aeaf30&scoped=true&"
import script from "./OptionalArticlesContainer.vue?vue&type=script&lang=js&"
export * from "./OptionalArticlesContainer.vue?vue&type=script&lang=js&"
import style0 from "./OptionalArticlesContainer.vue?vue&type=style&index=0&id=37aeaf30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aeaf30",
  null
  
)

export default component.exports